export default "__VITE_ASSET__771fe49b__"